import apiHelper from "../ApiHelper";

class CustomUploadAdapter {
    constructor(loader, site) {
        // The file loader instance to use during the upload.
        this.loader = loader;
        this.site = site;
    }

    // Starts the upload process.
    upload() {
        console.log("upload");
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                this._sendRequest(resolve, reject, file);
            }));
    }

    // Aborts the upload process.
    abort() {
        if (this.xhr) {
            console.log('abort');
            this.xhr.abort();
        }
    }

    // Prepares the data and sends the request.
    _sendRequest(resolve, reject, file) {
        // Prepare the form data.
        const genericErrorText = `Couldn't upload file: ${file.name}.`;

        if(this.site == 'hknt'){
            apiHelper.hknt.hkntUploadFile(file).then((response) => {
                resolve({
                    default: response.data.url
                });
            })
            .catch(error => {
                console.log(error);
                return reject(error ? error.message : genericErrorText);
            });
        }else{
            apiHelper.cinefan.uploadFile(file).then((response) => {
                resolve({
                    default: response.data.url
                });
            })
            .catch(error => {
                console.log(error);
                return reject(error ? error.message : genericErrorText);
            });
        }
        

    }
}

function CustomUploadAdapterPlugin(editor) {
    let site = editor.config._config.site;
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new CustomUploadAdapter(loader, site);
    };
}



export default CustomUploadAdapterPlugin;